<template>
    <router-link
        :to="{ name: 'product', params: { slug: product.slug } }"
        class="card-container text-decoration-none h-100"
    >
        <div class="card h-100 border-0 card-hover rounded-3">
            <div class="card-img-container">
                <div
                    class="card-img-top"
                    :style="{backgroundImage: `url(${product?.primaryImage?.url})`}"
                />
            </div>
            <div class="card-body text-lg-start text-center d-flex flex-column justify-content-between">
                <h5 class="card-title text-lg-start">{{ product.name }}</h5>
                <div class="pb-1">
                    <span
                        class="card-text attribute text-lg-start d-flex align-items-center mb-1"
                    >
                        <img
                            v-if="product.attributes[0]?.image.url"
                            width="auto"
                            height="15"
                            class="ms-1"
                            :src="product.attributes[0]?.image.url"
                            alt=""
                        />
                        <div
                            class="value ms-1 fw-semibold"
                            v-html="product.attributes[0]?.value"
                        ></div>
                        <br />
                    </span>
                    <div class="d-flex flex-column flex-md-row mt-2">
                        <span class="attribute card-text text-lg-start d-flex align-items-center mb-2 mb-md-0 me-md-4">
                            <img
                                v-if="product.attributes[1]?.image.url"
                                class="ms-1 me-1"
                                :src="product.attributes[1]?.image.url"
                                alt=""
                            />
                            <div
                                class="value fw-semibold"
                                v-html="product.attributes[1]?.value"
                            ></div>
                        </span>
                        <span
                            class="attribute card-text text-lg-start d-flex align-items-center"
                        >
                            <img
                                v-if="product.attributes[2]?.image.url"
                                width="15"
                                height="15"
                                class="ms-1 me-1"
                                :src="product.attributes[2]?.image.url"
                                alt=""
                            />
                            <div
                                class="value fw-semibold"
                                v-html="product.attributes[2]?.value"
                            ></div>
                        </span>
                    </div>
                </div>
            </div>
        </div>

    </router-link>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: ['product']
}
</script>

<style lang="scss" scoped>
.card-hover:hover {
    transform: scale(1.03);
    box-shadow: 0 0 20px 5px rgba(0,0,0,0.06);
}
.card {
    width: 240px;
    box-shadow: 0 0 10px 5px rgba(0,0,0,0.05);
    transition: 0.2s ease-in-out;
    .card-img-container {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 1rem 1rem 0 0;
        background: rgb(250, 249, 249);
        height: 300px;
        width: 100%;
    }
    .card-img-top {
        width:95%;
        height:95%;
        background-size: contain ;
        background-position: center;
        background-repeat: no-repeat;
    }
    .attribute{
        img{
            width: auto;
            height: 15px;
        }
    }
    .card-title{
        font-weight: 800;
    }
    .value {
        margin: 0;
        font-size: 13px;
    }
    @media(max-width:576px) {
        width: 140px;
        .card-img-container{
            height: 170px;
        }
        .card-title{
            font-size: 14px;
            margin-bottom: 15px;
        }
        .value{
            font-size: 10px;
            margin-bottom: 5px;
        }
        .attribute{
            height: 10px;
        }
        .card-body{
            padding: 8px;
        }
    }
}
</style>
